import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ProductsPage from "../pages/products/page";
import ProductDetailPage from "../pages/products/detail";
import SupplierRegisterPage from "../pages/supplier-register/page";
import CrownChatPage from "../pages/crownchat/page";
import FactoryAuthPage from "../pages/factory/auth/page";
import FactoryDashboard from "../pages/factory/dashboard/page";
import FactoryProductsPage from "../pages/factory/products/page";
import FactoryOrdersPage from "../pages/factory/orders/page";
import WholesalePage from "../pages/wholesale/page";
import CanadaWholesalePage from "../pages/canada-wholesale/page";
import ResellerLoginPage from "../pages/reseller/login/page";
import ResellerDashboard from "../pages/reseller/dashboard/page";
import ResellerBrowsePage from "../pages/reseller/browse/page";
import FactoryProfilePage from "../pages/reseller/factory/page";
import ResellerLeaderboardPage from "../pages/reseller/leaderboard/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/products",
    element: <ProductsPage />,
  },
  {
    path: "/products/:id",
    element: <ProductDetailPage />,
  },
  {
    path: "/supplier-register",
    element: <SupplierRegisterPage />,
  },
  {
    path: "/crownchat",
    element: <CrownChatPage />,
  },
  {
    path: "/factory/login",
    element: <FactoryAuthPage />,
  },
  {
    path: "/factory/signup",
    element: <FactoryAuthPage />,
  },
  {
    path: "/factory/dashboard",
    element: <FactoryDashboard />,
  },
  {
    path: "/factory/products",
    element: <FactoryProductsPage />,
  },
  {
    path: "/factory/orders",
    element: <FactoryOrdersPage />,
  },
  {
    path: "/wholesale",
    element: <WholesalePage />,
  },
  {
    path: "/canada-wholesale",
    element: <CanadaWholesalePage />,
  },
  {
    path: "/reseller/login",
    element: <ResellerLoginPage />,
  },
  {
    path: "/reseller/dashboard",
    element: <ResellerDashboard />,
  },
  {
    path: "/reseller/links",
    element: <ResellerDashboard />,
  },
  {
    path: "/reseller/earnings",
    element: <ResellerDashboard />,
  },
  {
    path: "/reseller/products",
    element: <ResellerBrowsePage />,
  },
  {
    path: "/reseller/payouts",
    element: <ResellerDashboard />,
  },
  {
    path: "/reseller/factory/:slug",
    element: <FactoryProfilePage />,
  },
  {
    path: "/reseller/leaderboard",
    element: <ResellerLeaderboardPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
